import { Calendar as CalendarIcon } from 'iconoir-react'
import { ReactElement } from 'react'
import { ActivitySections } from '../contacts/ContactRelatedObjects'
import ActivitiesIcon from '../Icon/ActivitiesIcon'
import { EmptySearch } from '../shared/styled/EmptySearch'

const getData = (type?: ActivitySections, isPatientLinked?: boolean) => {
  let data: { icon: ReactElement; title: string; message: string } | undefined
  const patientLinedMessage = isPatientLinked
    ? `If you believe this to be incorrect, please contact support.`
    : `This is due to the fact that the contact is not linked to a patient.`
  switch (type) {
    case ActivitySections.INBOX:
      data = {
        icon: <ActivitiesIcon />,
        title: `No Messages`,
        message: `This contact currently has no tracked communications.`,
      }
      break
    case ActivitySections.LEDGER:
      data = {
        icon: <CalendarIcon />,
        title: `No transactions`,
        message: `This contact currently has no transactions. ${patientLinedMessage}`,
      }
      break
    case ActivitySections.TREATMENT_PLANS:
      data = {
        icon: <CalendarIcon />,
        title: `No treatment plans`,
        message: `This contact currently has no treatment plans. ${patientLinedMessage}`,
      }
      break
    default:
      data = {
        icon: <ActivitiesIcon />,
        title: `No activities`,
        message: `This contact currently has no tracked communications. If you would like to see the other types of activities, please check the filters above.`,
      }
      break
  }
  return data
}

export function ActivityEmpty({
  type,
  isPatientLinked,
}: {
  type?: ActivitySections
  isPatientLinked?: boolean
}): ReactElement {
  const data: { icon: ReactElement; title: string; message: string } = getData(type, isPatientLinked)
  return <EmptySearch icon={() => data.icon} title={data.title} description={data.message} />
}
